<template>
  <button
      v-if="coachBill.coachingType === 'private_coaching'"
      class="btn btn-primary"
      @click.prevent="printPrivateCoaching">
    {{$t('general.print')}}
  </button>
  <button
      v-if="
        coachBill.coachingType === 'group_coaching' &&
        coachBill.billingType === 'pauschalbetrag'"
      class="btn btn-primary"
      @click.prevent="printGroupCoachingPauschal">
    {{$t('general.print')}}
  </button>
  <button
      v-else-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType !== 'pauschalbetrag'"
      class="btn btn-primary"
      @click.prevent="printGroupCoachingHourly">
    {{$t('general.print')}}
  </button>
  <button
      v-if="coachBill.coachingType === 'assisted_living_coaching'"
      class="btn btn-primary"
      @click.prevent="printAssistedLivingCoaching">
    {{$t('general.print')}}
  </button>
  <button
      v-if="coachBill.coachingType === 'case_management_coaching'"
      class="btn btn-primary"
      @click.prevent="printCaseManagementCoaching">
    {{$t('general.print')}}
  </button>
</template>

<script setup>
import { downloadFile } from '@/shared/functions';
import { defineProps } from 'vue';

const props = defineProps({
  coachBill: {
    type: Object,
    required: true,
  },
});

const printPrivateCoaching = () => {
  downloadFile(
      `/coach-billing/private-coaching/print-bill/${props.coachBill.id}`,
      undefined, undefined
  );
};

const printGroupCoachingHourly = () => {
  downloadFile(
      `/coach-billing/group-coaching/hourly-wages-bill-print/${props.coachBill.id}`,
      undefined,
  );
};

const printGroupCoachingPauschal = () => {
  downloadFile(
      `/coach-billing/group-coaching/pauschal-print/${props.coachBill.id}`,
      undefined,
  );
};

const printAssistedLivingCoaching = () => {
  downloadFile(
      `/coach-billing/assisted-living-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};

const printCaseManagementCoaching = () => {
  downloadFile(
      `/coach-billing/case-management-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};
</script>
